import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=6a3cf38e"
import script from "./order-detail.vue?vue&type=script&lang=js"
export * from "./order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports